const initCopyText = () => {
  document.querySelectorAll('[data-copy]').forEach((root) => {
    const button = root.querySelector('[data-copy-button]');
    const el = root.querySelector('[data-copy-element]');

    if (!button || !el) {
      return;
    }

    button.addEventListener('click', async () => {
      const text = el.textContent.trim();

      if (!text || !navigator.clipboard) {
        return;
      }

      await navigator.clipboard.writeText(text);
      button.classList.add('is-copied');
      window.setTimeout(() => {
        button.classList.remove('is-copied');
      }, 1500);
    });
  });
};

export {initCopyText};
